export default "__VITE_ASSET__kHyIBrk5__"